import { render, staticRenderFns } from "./XkPagination.vue?vue&type=template&id=2a53971f&scoped=true&"
import script from "./XkPagination.vue?vue&type=script&lang=js&"
export * from "./XkPagination.vue?vue&type=script&lang=js&"
import style0 from "./XkPagination.vue?vue&type=style&index=0&id=2a53971f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53971f",
  null
  
)

export default component.exports